import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2011Status: 'idle',
    startProcess2011Error: undefined as any,
    loadUserParamsProcess2011Status: 'idle',
    loadUserParamsProcess2011Error: undefined as any,

    process2011List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2011 = createAsyncThunk('process2011Slice/startProcess2011', async ({ process2011 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2011/`,
        prepareData(process2011),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2011Status } = getState().process2011Slice
        return startProcess2011Status !== 'pending'
    }
})

export const loadUserParamsProcess2011 = createAsyncThunk('process2011Slice/loadUserParamsProcess2011', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2011/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2011Status } = getState().process2011Slice
        return loadUserParamsProcess2011Status !== 'pending'
    }
})

const Process2011Slice = createSlice({
    name: 'process2011Slice',
    initialState,
    reducers: {
        resetstartProcess2011: (state) => {
            state.job = undefined
            state.startProcess2011Error = undefined
        },
        resetstartProcess2011Error: (state) => {
            state.startProcess2011Error = undefined
        },
        resetloadUserParamsProcess2011: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2011Error = undefined
        },
        resetloadUserParamsProcess2011Error: (state) => {
            state.loadUserParamsProcess2011Error = undefined
        },
        removeFromProcess2011ListById: (state, action) => {
            state.process2011List = state.process2011List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2011ListByIds: (state, action) => {
            state.process2011List = state.process2011List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2011List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2011Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2011List = []
            state.startProcess2011Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2011.pending, (state) => {
            state.startProcess2011Status = 'pending'
            state.startProcess2011Error = undefined
        })
        builder.addCase(startProcess2011.fulfilled, (state, action) => {
            state.startProcess2011Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2011.rejected, (state, action) => {
            state.startProcess2011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2011Error = action.error.message
            } else {
                state.startProcess2011Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2011.pending, (state) => {
            state.loadUserParamsProcess2011Status = 'pending'
            state.loadUserParamsProcess2011Error = undefined
        })
        builder.addCase(loadUserParamsProcess2011.fulfilled, (state, action) => {
            state.loadUserParamsProcess2011Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2011.rejected, (state, action) => {
            state.loadUserParamsProcess2011Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2011Error = action.error.message
            } else {
                state.loadUserParamsProcess2011Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2011,
    resetstartProcess2011Error,
    resetloadUserParamsProcess2011,
    resetloadUserParamsProcess2011Error,
    removeFromProcess2011ListById,
    removeFromProcess2011ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2011Slice.actions
export default Process2011Slice.reducer
